import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const InteriorStyling = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="71" viewBox="0 0 98 71" width="98" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path className={strokeStyle} d="M15.62 66.4h-3.83v-3.83a3.8 3.8 0 0 0 3.83 3.83Z" fill={shades.black} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M90.94 62.57v3.83h-3.87c2.13 0 3.87-1.7 3.87-3.83Z" fill={shades.black} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M90.94 37.3v25.27a3.84 3.84 0 0 1-3.87 3.83H15.62a3.8 3.8 0 0 1-3.83-3.83V37.31c0-2.2 1.78-3.98 4.02-3.98h5.02V22.36c0-6.06 4.94-11 11.05-11h38.97a11 11 0 0 1 11 11v10.97h5.07a4 4 0 0 1 4.01 3.98Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M18 4.43h55.3a2.87 2.87 0 0 1 2.86 2.87v30.22H15.13V7.3a2.87 2.87 0 0 1 2.86-2.87Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M85.23 40.51H6.07V59.5h79.16z" fill={shades.primary.medium} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M7.11 26.4h13.76c.58 0 1.04.46 1.04 1.04v31.04a1 1 0 0 1-1 1H7.08a1 1 0 0 1-1-1V27.44c0-.58.46-1.04 1.04-1.04Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M70.42 26.4h13.76c.57 0 1.04.46 1.04 1.04v31.04a1 1 0 0 1-1 1H70.37a1 1 0 0 1-1-1V27.44c0-.58.47-1.04 1.05-1.04Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M45.65 34.1H21.92v6.84h23.73z" fill={shades.white} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M69.37 34.1H45.65v6.84h23.72z" fill={shades.white} strokeWidth={strokeWidth} />
      <path d="M54.87 13.19v12.3h-6.15v-6.15h-6.14v6.14h-6.15V13.2z" fill={shades.black} />
    </svg>
  );
};
